var Component = require("!../../../node_modules/vue-loader/lib/component-normalizer")(
  /* script */
  require("!!babel-loader!./Loader.js"),
  /* template */
  require("!!../../../node_modules/vue-loader/lib/template-compiler?id=data-v-2b4e4c1c!../../../node_modules/vue-loader/lib/selector?type=template&index=0!./Loader.vue"),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports



//////////////////
// WEBPACK FOOTER
// ./src/components/Shared/Loader.vue
// module id = 213
// module chunks = 1